<script lang="ts">
  import type { Snippet } from 'svelte';

  interface Props {
    pressed: boolean;
    onclick: () => void;
    children: Snippet;
  }

  let { pressed, onclick, children }: Props = $props();
</script>

<button type="button" class="chip" class:on={pressed} aria-pressed={pressed} {onclick}>
  {@render children()}
</button>

<style>
  .chip {
    padding: var(--space-1) var(--space-3);
    font-size: 12px;
    color: var(--text-tertiary);
    background: var(--bg-elevated);
    border: 1px solid var(--border-subtle);
    border-radius: var(--radius-full);
    cursor: pointer;
    transition:
      color var(--duration-fast) var(--easing-default),
      border-color var(--duration-fast) var(--easing-default),
      background var(--duration-fast) var(--easing-default);
  }
  .chip:hover {
    color: var(--text-secondary);
  }
  .chip:focus-visible {
    outline: 2px solid var(--accent);
    outline-offset: 1px;
  }
  .chip.on {
    color: var(--accent);
    background: var(--accent-bg);
    border-color: var(--accent);
  }
</style>
